import { For, createContext, createEffect, createMemo, createSignal, useContext, Show, Switch, Match, Signal } from "solid-js";
import styles from './st-card.module.css'
import Icon from "../st-icon/st-icon";
import StSpinner from "../st-spinner/st-spinner";

type Size = "small" | "medium"

class StCardProps {
    label?: string
    value: string = ""
    size: Size = "medium"
    style?: string = ""
    icon?: string = ""
    iconColor?: string = ""
    filterActive?: Signal<boolean>
    showLoadingSpinner?: boolean = false
    dataLoaded?: boolean = false
}

export default function StCard(props: StCardProps) {
    return <StCardInner {...props} />
}
StCard.defaultProps = new StCardProps();

function StCardInner(props: StCardProps) {
    const [filterActive, setFilterActive] = props.filterActive ?? createSignal(false);

    const toggleFilterActive = (e: MouseEvent) => {
        e.stopPropagation();
        setFilterActive(!filterActive());
    }

    const showValue = createMemo(() => {
        var showSpinner = props.showLoadingSpinner;
        var dataLoaded = props.dataLoaded;
        
        return showSpinner !== true || dataLoaded === true;
    });

    return <div class={styles.StCard} classList={{ [styles.Filterable]: !!props.filterActive, [styles.FilterActiveCard]: filterActive() }} attr:card-size={props.size} attr:card-style={props.style}>
        <div onClick={toggleFilterActive} role="button">
            <div class={styles.CardLabel}>{props.label}</div>
            <div class={styles.CardValue}>
                <Switch fallback={<StSpinner size="small" />}>
                    <Match when={showValue()}>
                        <Show when={props.icon}>
                            <span
                                class={styles.CardIcon}
                                style={{
                                    'color': props.iconColor ?? '#000'
                                }}
                            >
                                <Icon src={props.icon ?? ""} />
                            </span>
                        </Show>
                        <span>{props.value}</span>        
                    </Match>
                </Switch>
                </div>
            <Show when={props.filterActive}>
                <div class={styles.FilterIcon}>
                    <Switch>
                        <Match when={filterActive()}>
                            <span class={styles.FilterActiveIcon}>
                                <Icon src="fa-solid fa-filter" />
                            </span>
                        </Match>
                        <Match when={filterActive() === false}>
                            <span class={styles.FilterInactiveIcon}>
                                <Icon src="fa-regular fa-filter" />
                            </span>
                        </Match>
                    </Switch>
                </div>
            </Show>
        </div>
    </div>
}
